import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import userinfo from 'store/modules/userinfo' ////用户信息仓库
import publicinfo from 'store/modules/publicinfo'
import configinfo from 'store/modules/configinfo'

export default new Vuex.Store({
  state: {
    ////用户的公共变量仓库  ///使用 this.$store.state.userinfo(子模组，没有时不写).userId（用户变量）
    token: ''
  },
  mutations: {
    ///同步提交信息的方法，组件中的使用 this.$store.commit('updataUserId（定义的方法名）' , '传入的参数')
    updataToken(state, token) {
      state.token = token
    }
  },
  actions: {
    ////使用方法：this.$store.dispatch('asyUpdataUserId',this.registerSubmitData.telePhone); ///异步提交用户的账号信息到仓库
    asyUpdataToken(context, token) {
      context.commit('updataToken', token)
    }
  },
  getters: {
    //获取token方法
    //判断是否有token,如果没有重新赋值，返回给state的token
    getToken(state) {
      console.log(state.token, 111)
      if (state.token === '') {
        state.token = sessionStorage.getItem('token')
      }
      return state.token
    }
  },
  modules: {
    ////子模组
    userinfo,
    publicinfo,
    configinfo
  }
})

// import store from 'store/index'  ///导入公共仓库
